/*
  Century OG: mobile menu submenus expand in place (accordion) instead of sliding
  to a separate panel. Active when the drawer has the .menu-drawer--accordion class
  (header setting "Expand mobile menu items in place").
*/
(() => {
  const SUMMARY = '.menu-drawer--accordion .menu-drawer__navigation details > summary';
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setOpen = (details, open) => {
    const summary = details.querySelector(':scope > summary');
    const panel = details.querySelector(':scope > .menu-drawer__submenu');
    if (open) {
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      if (panel && !reduceMotion() && panel.animate) {
        panel.animate(
          [
            { opacity: 0, transform: 'translateY(-6px)' },
            { opacity: 1, transform: 'none' },
          ],
          { duration: 220, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' }
        );
      }
    } else {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      details.querySelectorAll('details[open]').forEach((child) => setOpen(child, false));
    }
  };

  // Capture phase: runs before Dawn's own summary handlers (which slide a panel in).
  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest(SUMMARY);
      if (!summary) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      const details = summary.parentElement;
      const willOpen = !details.hasAttribute('open');
      if (willOpen) {
        const list = details.closest('ul');
        if (list) {
          list.querySelectorAll(':scope > li > details[open]').forEach((other) => {
            if (other !== details) setOpen(other, false);
          });
        }
      }
      setOpen(details, willOpen);
    },
    true
  );

  // Collapse everything when the drawer itself closes, so it reopens tidy.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('#Details-menu-drawer-container > summary')) return;
    window.setTimeout(() => {
      const container = document.getElementById('Details-menu-drawer-container');
      if (container && !container.hasAttribute('open')) {
        container.querySelectorAll('.menu-drawer--accordion details[open]').forEach((d) => setOpen(d, false));
      }
    }, 400);
  });
})();
